import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../diccionarios/moduloVMI';
import {ColorAlertaModel} from '../../models/vmi-color-alertaModel';

@Injectable({
  providedIn: 'root'
})
export class VmiAlertasService {

  diccionarioUrl: any = {};
  url: string;

  constructor(
    private _commom: CommonService,
    private _utils: UtilsService
  ) {
    this.url = this._utils.getVmi();
    this.diccionarioUrl = moduloVMI.url.administracion;
  }

  getAll(): Observable<ColorAlertaModel[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.alertas);
  }

  create(innObj: ColorAlertaModel): Observable<any> {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioUrl.alertas, innObj);
  }

  edit(innObj: ColorAlertaModel): Observable<any> {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioUrl.alertas, innObj);
  }

  delete(innIdObj: number): Observable<any> {
    return this._commom.peticionDeleteConHeader(this.url + this.diccionarioUrl.alertas + `/${innIdObj}`);
  }
}
